module.exports = {
  localeName: 'cs-CZ',
  momentFormat: 'DD.MM.YYYY',
};
